module.exports = __webpack_public_path__ + "static/media/PolaroidNormal3.5by4.2_2.59a831cc.webp";